import Application from "../../Application";
import GetEvaluationTypesInteractor from "./GetEvaluationTypesInteractor";
import EvaluationTypesPresenter, {
  IEvaluationTypesPresenter
} from "../../presenter/evaluation/EvaluationTypesPresenter";
import GetRuleGroupsInteractor from "./GetRuleGroupsInteractor";

export default class ShowEvaluationTypesInteractor {
  private application: Application;
  private getEvaluationTypes: GetEvaluationTypesInteractor;
  private output?: IEvaluationTypesPresenter;
  private getRuleGroups: GetRuleGroupsInteractor;

  constructor(application, getEvaluationTypes, getRuleGroups) {
    this.application = application;
    this.getEvaluationTypes = getEvaluationTypes;
    this.getRuleGroups = getRuleGroups;
  }

  execute() {
    this.output = EvaluationTypesPresenter({
      application: this.application,
      initialState: {
        evaluationTypes: []
      }
    });

    this.getEvaluationTypes.execute().then(this.output.setEvaluationTypes);
    this.getRuleGroups.execute().then(this.output.setRuleGroups);

    return this.output;
  }
}
